<template>
<div id="app">
  <vue-headful :title="brand == 'CHEBONUS' ? 'Vaillant CheBonus': 'Hermann Saunier Duval HappyBonus'" description="Incentivi fiscali. Ci pensiamo noi. Offri ai tuoi clienti sconti immediati direttamente in fattura. Noi gestiamo tutta la parte burocratica" />
  <div class="main">

    <navigation />

    <div class="main-container">

      <router-view />

    </div>

  </div>

  <sqreen-footer />

</div>
</template>

<style lang="css" scoped>

  @import'~bootstrap/dist/css/bootstrap.min.css';
  @import './assets/css/main.css';

</style>

<script>
import Navigation from 'components/navigation'
import {
  USER_REQUEST
} from 'actions/user'
import SqreenFooter from './components/footer/index.vue'
import {
  mapGetters
} from 'vuex'

import axios from 'axios'


import (process.env.BRAND == 'HAPPYBONUS' ? './assets/css/hsd.css' : './assets/css/vaillant.css')


export default {
  components: {
    SqreenFooter,
    Navigation,
    //loading,
  },
  name: 'app',
  data() {
    return {
      fullscreen: false,
      restoreId: false,
      brand: process.env.BRAND,
      popupbg: process.env.BRAND == 'CHEBONUS' ? 'linear-gradient(0deg, #00917e, #00dcbf)' : 'linear-gradient(0deg, #cd0c2d, #ff6680)',
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'userPaid', 'getProfile']),
  },
  watch: {
    isAuthenticated: function() {

      var _vue = this

      this.$store.dispatch(USER_REQUEST).then((resp) => {
        console.log('LOG USER')

        setTimeout(function() {
          if (_vue.userPaid == 'yes') {
            //_vue.initiateCall()
          }
        }, 2500)
      })
    }
  },
  methods: {
    initFreshChat() {
      console.log('initFreshChat')
      var _vue = this

      window.fcWidget.init({
        token: "8bf45de4-3dc3-4817-8dca-ea03e411009e",
        host: "https://wchat.freshchat.com",
        externalId: _vue.getProfile.partita_iva,
        restoreId: _vue.getProfile.freshchatID ? _vue.getProfile.freshchatID : null,
        locale: "it",
        tags: ["chebonus", "consulenzafiscale"],
        siteId: "CHEBONUS"
      });

      var firstName = _vue.getProfile.name
      var lastName = _vue.getProfile.cognome
      var email = _vue.getProfile.email
      var phone = _vue.getProfile.cellulare ? _vue.getProfile.cellulare : _vue.getProfile.telefono

      var data1 = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        phoneCountryCode: "+39",
        plan: "Estate",
        status: "Active"
      }
      console.log( data1 )
      window.fcWidget.user.get(function(resp) {
        console.log( resp )
        var status = resp && resp.status,
          data = resp && resp.data;
        if (status !== 200) {
          console.log( 'STATUS => USER NOT FOUND' )


          window.fcWidget.user.setProperties(data1);
          window.fcWidget.on('user:created', function(resp) {
            console.log( 'USER_CREATED' )
            var status = resp && resp.status,
              data = resp && resp.data;
            if (status === 200) {
              if (data.restoreId) {
                // Update restoreId in your database
                console.log( data.restoreId )
                _vue.restoreId = data.restoreId
                _vue.editUser()

              }
            }
          });
        }else{
          console.log( 'EXIST USER FRESHCHAT' )
        }
      },data1);

    },
    initialize(i, t) {
      console.log('initialize')
      var e;
      i.getElementById(t) ? this.initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = this.initFreshChat, i.head.appendChild(e))
    },
    initiateCall() {
      console.log('initiateCall')
      this.initialize(document, "freshchat-js-sdk")
    },
    editUser() {

          this.loadingState = true
          var data = {
            email: this.getProfile.email,
            freshchatID: this.restoreId
          }

          axios({
              url: process.env.ROOT_API + 'api/editUser',
              method: 'POST',
              data: {
                user: data,
                regType: 'new',
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              this.$store.dispatch(USER_REQUEST)
              //this.proccess = 'REG_SUCCESS'
              this.loadingState = false
            })
            .catch(error => {
              this.loadingState = false
            })

    },


  },
  async mounted() {
    if (this.isAuthenticated) {
      var _vue = this

      this.$store.dispatch(USER_REQUEST).then((resp) => {
        console.log('LOG USER')
        setTimeout(function() {
          if (_vue.userPaid == 'yes') {
            //_vue.initiateCall()
          }
        }, 2500)

      })

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue